import request from '@/utils/request';
import config from '@/config';

const { apiInfo } = config;
const systemUrl = `${apiInfo.system.prefix}${apiInfo.system.group}`;

export function login(userName, password, userAccount) {
    const url = '/api/Token/Login';

    return request({
        url: url,
        method: 'post',
        data: {
            username: userName,
            password: password,
            userAccount: userAccount
        }
    });
}

export function getCountry() {
    const url = systemUrl + '/Country';

    return request({
        url: url,
        method: 'get'
    });
}

export function getCategory(userCountry, filterValue) {
    const url =
        systemUrl +
        '/Category' +
        `?userCountry=${userCountry}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getBrand(userCountry, category, filterValue) {
    const url =
        systemUrl +
        '/Brand' +
        `?userCountry=${userCountry}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getSubbrand(userCountry, category, filterValue) {
    const url =
        systemUrl +
        '/Subbrand' +
        `?userCountry=${userCountry}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getForm(userCountry, category, filterValue) {
    const url =
        systemUrl +
        '/Form' +
        `?userCountry=${userCountry}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getVariant(userCountry, category, filterValue) {
    const url =
        systemUrl +
        '/Variant' +
        `?userCountry=${userCountry}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getSize(userCountry, category, filterValue) {
    const url =
        systemUrl +
        '/Size' +
        `?userCountry=${userCountry}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getCustomerChannel(
    country,
    category,
    runratetype,
    filterValue
) {
    const url =
        systemUrl +
        '/CustomerChannel' +
        `?country=${country}&category=${category}&runratetype=${runratetype}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getFactbookMedia(data) {
    const url = systemUrl + '/FactbookText';

    return request({
        url: url,
        method: 'post',
        data: data
    });
}

export function getTdProduct(country, category, filterValue) {
    const url =
        systemUrl +
        '/TdProduct' +
        `?country=${country}&category=${category}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}
export function FactbookTopOne(data) {
    const url = systemUrl + '/FactbookTopOneText';

    return request({
        url: url,
        method: 'post',
        data: data
    });
}
export function getWorkflow(approveStatus) {
    const url = systemUrl + '/WorkFlow' + `?approveStatus=${approveStatus}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getPingData(params) {
    return request({
        url: 'api/Login/Ping',
        method: 'get',
        params
    });
}

export function revoke(data) {
    return request({
        url: 'api/Login/Revoke' + `?refreshtoken=${data}`,
        method: 'post'
    });
}

export function FactbookTopOneText(data) {
    const url = systemUrl + '/FactbookTopOneText';

    return request({
        url: url,
        method: 'get'
    });
}
export function getUserName(filter) {
    const url = systemUrl + '/UserName' + `?filterValue=${filter}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function getTDCatrgory(userCountry, filterValue) {
    const url =
        systemUrl +
        '/CategoryOrigi' +
        `?userCountry=${userCountry}&filterValue=${filterValue}`;

    return request({
        url: url,
        method: 'get'
    });
}

export function downloadAzureFile(params) {
    return request({
        url: '/api/System/AzureFile',
        method: 'get',
        action: 'file',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/system.js